import React, { useState, useEffect } from "react";
import axios from "axios";
import { exportarAExcel } from "../utils/exportExcel";

const CombustibleForm = () => {
  const [fecha, setFecha] = useState("");
  const [formData, setFormData] = useState({
    fecha: "",
    cantidad: "",
    tipoCombustible: "",
    horasUso: "",
    comentarios: "",
  });
  const apiurl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const hoy = new Date();
    const yyyy = hoy.getFullYear();
    const mm = String(hoy.getMonth() + 1).padStart(2, "0");
    const dd = String(hoy.getDate()).padStart(2, "0");
    setFecha(`${yyyy}-${mm}-${dd}`);
  }, []);

  const formatearFecha = (fechaIso) => {
    const fecha = new Date(fechaIso);
    const dia = String(fecha.getDate()).padStart(2, "0");
    const mes = String(fecha.getMonth() + 1).padStart(2, "0"); // ¡Mes comienza en 0!
    const anio = fecha.getFullYear();
    return `${dia}-${mes}-${anio}`;
  };

  const handleExcel = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.get(`${apiurl}/getCombustible`);
      const data = response.data.map((item) => ({
        ...item,
        fecha: formatearFecha(item.fecha),
      }));
      exportarAExcel(data, "registros_combustible.xlsx");
    } catch (error) {
      console.error("Error al obtener los registros:", error);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    formData.fecha = fecha;
    try {
      await axios.post(`${apiurl}/combustible`, formData);
      alert("✅ Registro de combustible enviado correctamente");
      setFormData({
        fecha: "",
        cantidad: "",
        tipoCombustible: "",
        horasUso: "",
        comentarios: "",
      });
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      alert("❌ Error al guardar los datos");
    }
  };

  return (
    <>
      <div className="wrapper2">
        <form className="form-side2" onSubmit={handleSubmit}>
          <h2>Registro de Combustible</h2>

          <label>Fecha:</label>
          <input
            type="date"
            value={fecha}
            onChange={(e) => setFecha(e.target.value)}
            required
          />

          <label>Cantidad (Litros):</label>
          <input
            type="number"
            step="0.01"
            value={formData.cantidad}
            onChange={(e) =>
              setFormData({ ...formData, cantidad: e.target.value })
            }
            required
          />

          <label>Tipo de combustible:</label>
          <input
            type="text"
            value={formData.tipoCombustible}
            onChange={(e) =>
              setFormData({ ...formData, tipoCombustible: e.target.value })
            }
            required
          />
          <label>Horas de uso:</label>
          <input
            type="number"
            value={formData.horasUso}
            onChange={(e) =>
              setFormData({ ...formData, horasUso: e.target.value })
            }
          />

          <label>Observaciones:</label>
          <textarea
            value={formData.comentarios}
            onChange={(e) =>
              setFormData({ ...formData, comentarios: e.target.value })
            }
          />
          <div className="form-buttons">
            <button type="submit">Guardar</button>
            <button
              style={{ fontSize: "15px", backgroundColor: "#064e3b" }}
              onClick={handleExcel}
            >
              Descargar Registros
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default CombustibleForm;
